import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumericValue } from 'utils/general';

import { WidgetTooltip } from '@/modules/home';
import { useGetOperationsWidgets } from '@/modules/home/apiHooks';
import { sumOperation } from '@/modules/home/components/PageContent/HeroNumbers/HeroNumberWidgets/logic';
import { useHomePageContext } from '@/modules/home/context';
import { IHome } from '@/modules/home/types';
import { Widget } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import ClipboardArrowIn from '~/images/shared/ClipboardArrowIn.svg';
import ClipboardCheck from '~/images/shared/ClipboardCheck.svg';
import ClipboardClose from '~/images/shared/ClipboardClose.svg';
import FilledExleminationMark from '~/images/shared/FilledExleminationMark.svg';
import FilledLocation from '~/images/shared/FilledLocation.svg';

const HeroNumberWidgets = () => {
  const emptyOperation: IHome.IOperationsWidgetSchema = {
    periodic: 0,
    technical: 0,
  };
  const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store?.asset);
  const {
    state: { date },
  } = useHomePageContext();

  const { data } = useGetOperationsWidgets({
    entityId: selectedAsset?.id,
    date: format(date, 'yyyy-MM-dd'),
  });

  return (
    <div className='flex flex-wrap justify-between gap-16'>
      {selectedAsset?.entityTypeId === 2 && (
        <Widget
          title={t('planned')}
          number={formatNumericValue(sumOperation(data?.todo))}
          icon={<ClipboardClose />}
          className='max-w-[48%] desktop:max-w-[18%]'
          moreContent={
            <WidgetTooltip
              type='todo'
              operation={data?.todo ?? emptyOperation}
            />
          }
        />
      )}
      <Widget
        title={t('in-progress')}
        number={formatNumericValue(sumOperation(data?.inprogress))}
        icon={<ClipboardArrowIn />}
        className={`max-w-[48%] ${
          selectedAsset?.entityTypeId === 2
            ? 'desktop:max-w-[18%]'
            : 'desktop:max-w-[23%]'
        }`}
        moreContent={
          selectedAsset?.entityTypeId === 2 && (
            <WidgetTooltip
              type='inprogress'
              operation={data?.inprogress ?? emptyOperation}
            />
          )
        }
      />
      <Widget
        title={t('done')}
        number={formatNumericValue(sumOperation(data?.done))}
        icon={<ClipboardCheck />}
        className={`max-w-[48%] ${
          selectedAsset?.entityTypeId === 2
            ? 'desktop:max-w-[18%]'
            : 'desktop:max-w-[23%]'
        }`}
        moreContent={
          selectedAsset?.entityTypeId === 2 && (
            <WidgetTooltip
              type='done'
              operation={data?.done ?? emptyOperation}
            />
          )
        }
      />
      <Widget
        title={t('active-fields')}
        number={formatNumericValue(sumOperation(data?.activeFields))}
        icon={<FilledLocation />}
        className={`max-w-[48%] ${
          selectedAsset?.entityTypeId === 2
            ? 'desktop:max-w-[18%]'
            : 'desktop:max-w-[23%]'
        }`}
      />
      <Widget
        title={t('alerts')}
        number={formatNumericValue(sumOperation(data?.alerts))}
        icon={<FilledExleminationMark />}
        numberStyle={sumOperation(data?.alerts) > 0 ? 'text-error-400' : ''}
        className={`max-w-[48%] ${
          selectedAsset?.entityTypeId === 2
            ? 'desktop:max-w-[18%]'
            : 'desktop:max-w-[23%]'
        }`}
      />
    </div>
  );
};
export { HeroNumberWidgets };
